import React from "react";
import { withStyles, Typography } from "@material-ui/core";
import clsx from "clsx";

const styles = theme => ({
  root: {
    display: "flex",
    alignItems: "center",
  },
  interpreterRequiredText: {
    color: theme.palette.error.main, // red color
    fontWeight: "bold",
    fontSize: "medium",
  },
});

function InterpreterRequiredContent(props) {
  const { classes, requiredLanguage } = props;
  return (
    <div className={classes.root}>
      <Typography className={clsx(classes.interpreterRequiredText)}>
        {`Interpreter Required${requiredLanguage ? ` (${requiredLanguage})` : ""}`}
      </Typography>
    </div>
  );
}

export default withStyles(styles)(InterpreterRequiredContent);
